<template>
  <v-flex mb-5>
    <v-card class="mx-auto card-border" max-width="800">
      <v-card-title>
        <div class="headline mb-1 blue-grey--text text--darken-2">
          <strong>{{ testimonial.title }}</strong>
        </div>
        <v-spacer></v-spacer>
        <v-rating
          :value="rating"
          medium
          readonly
          background-color="orange lighten-3"
          color="amber"
        >
        </v-rating>
      </v-card-title>
      <v-card-text>
        <p class="mb-1">{{ testimonial.message }}</p>
        <p class="ml-3 font-italic">~ {{ testimonial.author }}</p>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'Testimonial',
  props: {
    testimonial: { type: Object, required: true },
  },
  data() {
    return {
      rating: this.testimonial.value,
    };
  },
};
</script>

<style scoped>
.card-border {
  border-left: #ffc107 solid 2px;
}
</style>
